var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell1827347(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.66,
    height: 19.992,
    viewBox: "0 0 16.66 19.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell_1827347",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63347",
    "data-name": "Path 63347",
    d: "M16.143,13.871a5.459,5.459,0,0,1-1.982-4.2V7.381a5.775,5.775,0,0,0-5-5.675V.82A.833.833,0,0,0,7.5.82v.886a5.775,5.775,0,0,0-5,5.675V9.668A5.465,5.465,0,0,1,.51,13.877,1.424,1.424,0,0,0,0,14.967,1.448,1.448,0,0,0,1.458,16.4H15.2a1.448,1.448,0,0,0,1.458-1.435A1.429,1.429,0,0,0,16.143,13.871Zm0,0",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63348",
    "data-name": "Path 63348",
    d: "M138.25,450.692a3.371,3.371,0,0,0,3.3-2.692h-6.595A3.371,3.371,0,0,0,138.25,450.692Zm0,0",
    transform: "translate(-129.92 -430.7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell1827347);
export default __webpack_public_path__ + "static/media/bell_1827347.7c1efa9c5bddb3e23af15e60fefb3ab9.svg";
export { ForwardRef as ReactComponent };